// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function opportunity_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var external_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "external_id"), null));
  if (external_id.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              external_id: external_id._0
            }
          };
  }
  var e = external_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".external_id" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var opportunity = opportunity_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "opportunity"), null));
  if (opportunity.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              opportunity: opportunity._0
            }
          };
  }
  var e = opportunity._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".opportunity" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  opportunity_decode ,
  t_decode ,
}
/* No side effect */
